function initInstantsearchHeader() {
  let initialized = false;
  const headerSearchClient = algoliasearch(
    'F9HCDR2SMH',
    '6796a647ff7046ff14ebe5a07a5c8ec0'
  );
  const indexName = 'shopify_products';
  const insightsMiddleware = instantsearch.middlewares.createInsightsMiddleware(
    {
      insightsClient: null,
      onEvent: event => {
        window.trackAlgoliaEvent(event);
      }
    }
  );
  const headerSearch = instantsearch({
    indexName,
    searchClient: headerSearchClient
  });

  let currentQuery;
  const header_searchResults = customHits({
    container: document.querySelector('#instantsearch-products')
  });
  const header_querySuggestions = instantsearch.widgets
    .index({ indexName: 'shopify_products_query_suggestions' })
    .addWidgets([
      instantsearch.widgets.configure({
        hitsPerPage: 5,
        clickAnalytics: true,
        getRankingInfo: true,
        userToken: analytics?.user?.().anonymousId?.() ?? ''
      }),
      instantsearch.widgets.hits({
        container: '#instantsearch-suggestions',
        templates: {
          item: renderCollection
        }
      })
    ]);
  const header_searchBox = instantsearch.widgets.searchBox({
    container: '#instantsearch',
    placeholder: 'What are you looking for?',
    queryHook(query, search) {
      currentQuery = query;
      search(query);
    }
  });
  const header_configure = instantsearch.widgets.configure({
    hitsPerPage: 4,
    clickAnalytics: true,
    distinct: true,
    getRankingInfo: true
  });
  headerSearch.addWidgets([
    header_searchBox,
    header_configure,
    header_searchResults,
    header_querySuggestions
  ]);
  headerSearch.use(insightsMiddleware);
  headerSearch.on('render', async p => {
    // Check if in Algolia A/B test
    if (headerSearch.renderState[indexName].hits?.results?.abTestID) {
      // Set GTM properties to track test variant group
      window.dataLayer.push({
        algoliaIndexUsed: indexName,
        algoliaABTestID: `${headerSearch.renderState[indexName].hits.results.abTestID}`,
        algoliaABTestVariantID: `${headerSearch.renderState[indexName].hits.results.abTestVariantID}`,
        event: 'algoliaSearchInformation'
      });
    }
    if (headerSearch.renderState[indexName].hits?.results?.queryID) {
      localStorage.setItem(
        'queryID',
        headerSearch.renderState[indexName].hits.results.queryID
      );
    }
    document
      .querySelector('#instantsearch-products')
      .querySelectorAll('.product-card')
      .forEach((card, idx) => {
        card.addEventListener('click', () => {
          // Algolia event tracking: /assets/instantsearch-global.js
          window.trackProductClick({
            objectID: card.dataset.variantId,
            position: idx + 1
          });
        });
      });
  });

  if (!initialized) {
    headerSearch.start();
    initialized = true;
  }

  function renderCollection(hit) {
    return `
      <a class="instantsearch__collection" href='/search?q=${hit.query}'>${hit.query}</a>
    `;
  }
  $(document).ready(function () {
    $('.search-overlay').on('click', function () {
      $('body').removeClass('search-open');
    });
    $('#instantsearch form').on('submit', function (e) {
      window.location = `/search?q=${currentQuery}`;
    });
  });
}

$(document).ready(function () {
  $('#search-control').on('focus', function () {
    initInstantsearchHeader();
    $('body').addClass('search-open');
    $('.header-search').addClass('active');
    $('.header-search input').focus();
    let headerSearchInput = document.querySelector('.ais-SearchBox-input');
    // set required attribute
    if (headerSearchInput) {
      headerSearchInput.setAttribute('required', '');
      let headerSearchForm = headerSearchInput.closest('.ais-SearchBox-form');
      // block empty search
      if (headerSearchForm) {
        headerSearchInput.addEventListener('keydown', function (event) {
          if (event.keyCode === 13 && headerSearchInput.value.trim() === '') {
            event.preventDefault();
          }
        });
      }
    }
  });
});
